import React, { useEffect, useState, useMemo,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetClientActions,
  setCLientDeleteActions,
  SetTHeNavigateList,
  getSideBarfilesActions,
  setID,
  setClient_objects_store,
  setTheClientNamelisted, ///----fro getting the client name list
  setTablePositionPersist,
  setClientBranchActions
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import ClientCreate from "./ClientCreate";
import Delete from "../../AppComponent/Popup/Delete";
import "../../../StyleSheet/MainComponent/Client/Client.scss";
import { useNavigate } from "react-router-dom";
import clientimg from "../../../Assets/AppComponent/icons/Client/Vector.svg";
import data from "../../../Json/Language/English";
import hindiDatas from "../../../Json/Language/Hinid";
import { NavLink } from "react-router-dom";
import Select from "react-select";
import _ from "lodash";

import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";

const Client = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const dispatch = useDispatch();
  const State = useSelector((state) => state);
    const TablePositionPersist = useSelector(state=>state.PreviousPagePosition.TablePositionPersist)

  const [Data, setdatas] = useState([]);
  const [dtpageindex, setdtPageindex] = useState(TablePositionPersist?.clientPage?.page==undefined?1:TablePositionPersist.clientPage.page);
  const [dtpagesize, setdtPagesize] = useState(20);
  const [pageSize, setPageSize] = useState(20);
  const [search, setsearch] = useState(TablePositionPersist?.clientPage?.search == "" || TablePositionPersist?.clientPage?.search ==undefined? "":TablePositionPersist.clientPage.search);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [ClientCreatePOpup, setClientcreate] = useState(false);
  const [EditID, setEditId] = useState("");
  const [DeleteID, setDeleteID] = useState("");
  const [DeletePOPUP, setDeletePOPUP] = useState(false);
  const [MakeCreate, setCreateBar] = useState(true);
  const navigate = useNavigate();
  const EnglishData = data;
  const HindiData = hindiDatas;
  const [projectlist, setporojectlits] = useState({ preArea: "", project: "" });
  const [preArea, setPrarea] = useState("");
  const [preAreaOptions, setPreAreaOP] = useState();

  const [yearAndMonth, setYearMpnth] = useState();
  const date = new Date();
  console.log(date.getFullYear(), "date");
  const months =
    date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth();
  console.log(yearAndMonth, "yearAndMonth");
  //var yearAndMonth = `${date.getFullYear()}-${months}`;
  useEffect(() => {
    setYearMpnth(`${date.getFullYear()}-${months}`);
  }, []);

  const [Datamonth, setdata] = useState({
    month: months,
    year: date.getFullYear(),
  });

  ////---- end of the filters
  const [monthYearset, setMonthYear] = useState("");

  ///-----Month and yar based filter
  ////------month and year based filters-------------------------------
  const handleChange = (e) => {
    setMonthYear(e.target.value);
    const months = new Date(e.target.value);
    // months.getMonth()
    console.log(months.getMonth() + 1, "months", months.getFullYear());
    const selectedmonth =
      months.getMonth() < 10
        ? `0${months.getMonth() + 1}`
        : months.getMonth() + 1;
    setYearMpnth(`${months.getFullYear()}-${selectedmonth}`);
    console.log(e.target.value, "weurweydsfsd", selectedmonth);
    setdata({
      ...Datamonth,
      month: selectedmonth,
      year: months.getFullYear(),
    });
  };

  useEffect(() => {
    const payloads = {
      search: search,
      page_size: 20,
      page: dtpageindex,
    };
    dispatch(SetClientActions(payloads));
    //  if (State.ClientList.ClientLists.length==0 || TablePositionPersist?.clientPage?.page!=dtpageindex || TablePositionPersist?.clientPage?.search!=search) {
      dispatch(setTablePositionPersist({data:payloads,pageName:"clientPage"}))


    // }
    currentRef.current.scrollTop=sessionStorage.getItem("clientTableScrollPosition")

  }, [ dtpageindex, search]);
  console.log(TablePositionPersist ,"TablePositionPersist", search);
  

  console.log(projectlist, "projectlist");
  const [project_number, setprojectnumber] = useState();
  useEffect(() => {
    if (State.ClientList.ClientLists != undefined) {
      let objectproject = [];
      let objectPreAear = [];
      State.ClientList.ClientLists.forEach((element) => {
        console.log(element, "element");
        objectproject.push({
          value: element.project_number,
          label: element.project_number,
        });
        objectPreAear.push({
          value: element.pre_area,
          label: element.pre_area,
        });
      });
      setPreAreaOP(objectPreAear);
      console.log(objectproject, "objectproject");
      setprojectnumber(objectproject);
    }
  }, [projectlist, preArea, State.ClientList.ClientLists]);


  const handleNext = (next) => {    
        setdtPageindex(next + 1);
  };

   const GotoEnteredPage =(gotopage)=>{
     setdtPageindex(gotopage)
   }

   const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
   
    }
  };

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    ///  console.log(arg, "args");
    setdtPageindex(arg);
  };

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
    setsearch(e);
      }, 500),
    []
  );

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);


  const HandelDelete = () => {
          setsearch("");
      setdtPageindex(1)
     const payloads_tocall = {
      search: "",
      page_size: 20,
      page: 1,
      };
      dispatch(setTablePositionPersist({data:payloads_tocall,pageName:"clientPage"}))

    if (DeleteID != undefined) {
      const payload = {
        DeleteID: DeleteID,
        currentPage: currentPage,
        project_number: projectlist,
        pre_area: preArea,
      };
      dispatch(setCLientDeleteActions(payload, setDeletePOPUP(false)));
    }
  };

  const handleClick = (id) => {
         const newEntry = { to_call: true };
            const result = { ...TablePositionPersist.clientBranchPage, ...newEntry };
            
            dispatch(
              setTablePositionPersist({
                data: result,
                pageName: "clientBranchPage",
              }))
              console.log(id ,"asodyasiod id");
              
        dispatch(setID(id));

    navigate("/clientbranch");
    // dispatch(SetTHeNavigateList("/"))
    // dispatch(SetTHeNavigateList(["/Clientbranch"]))
    //dispatch(getSideBarfilesActions("/clientbranch"))
  };

  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + "...";
  };

  const formatedDateListwithouttime = (dateString) => {
    const date = new Date(dateString);

    // Options for date formatting (only date)
    const dateOptions = {
        month: "short", // e.g., Dec
        day: "2-digit", // e.g., 22
        year: "numeric", // e.g., 2024
    };

    // Options for time formatting (only time)
    const timeOptions = {
        hour: "2-digit", // e.g., 02
        minute: "2-digit", // e.g., 16
        hour12: true, // e.g., AM/PM format
    };

    // Format the date and time separately
    const formattedDate = date.toLocaleDateString("en-US", dateOptions);
    const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

    // Combine the formatted date and time
    return `${formattedDate}`;
};

  const columns = [
    {
      Header: "Client",
      accessor: "",
      Cell: (row) => {
        const [showTooltip, setShowTooltip] = useState(false);

        return (
          <>
            <div
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
              style={{ position: 'relative' }} 
        className=" UserName"
            >
              {row.row.original.client_name != undefined &&
              row.row.original.client_name != null &&
              row.row.original.client_name != "" ? (
                <div className="IconsDesign">
                  {/* <div> */}
                  {/* <img src={clientimg} /> */}
                  {/* </div> */}
                  <span
                  >
                    {
                    // row.row.original.client_name.length > 35 ? (
                    //   <>{row.row.original.client_name.slice(0, 32)}...</>
                    // )
                    //  :
                      (
                      <>{row.row.original.client_name}</>
                    )
                    }
                                      {showTooltip && (
                          <div className="custom-tooltip-branch">
                            {row.row.original.client_name}
                          </div>
                         )} 
                  </span>


                </div>
              ) : (
                <span>{"---"}</span>
              )}
            </div>
          </>
        );
      },
    },
    {
      Header: "Description",
      accessor: "",
      Cell: (row) => {
        const [showTooltip, setShowTooltip] = useState(false);

        return (
          <>


            <span>
            <div className="UserName" 
            // onMouseEnter={() => setShowTooltip(true)} 
            // onMouseLeave={() => setShowTooltip(false)}
            style={{ position: 'relative' }} // Ensure the tooltip is positioned correctly
          >
              {row.row.original.description != null &&
              row.row.original.description != undefined &&
              row.row.original.description != "" ? (
                <span
                >
                  {/* {row.row.original.description} */}
                  {
                  row.row.original.description.length > 35 ? (
                    <>
                      {row.row.original.description
                        ? truncateText(row.row.original.description, 32)
                        : "---"}
                    </>
                  ) :
                   (
                    <>{row.row.original.description}</>
                  )
                  
                  }
                              {showTooltip && (
              <div className="custom-tooltip-branch">
                {row.row.original.description}
              </div>
            )}
                </span>
                
              ) : (
                <span>{"---"} </span>
              )}
                              </div>

            </span>
          </>
        );
      },
    },
    // {
    //   Header: "Pre Area",
    //   accessor: "",
    //   Cell: (row) => {
    //     return (
    //       <>
    //         <span>
    //           {row.row.original.pre_area != null &&
    //           row.row.original.pre_area != "" ? (
    //             <span>{row.row.original.pre_area}</span>
    //           ) : (
    //             <span>{"---"} </span>
    //           )}
    //         </span>
    //       </>
    //     );
    //   },
    // },
    // {
    //   Header: "Project Number",
    //   accessor: "",
    //   Cell: (row) => {
    //     return (
    //       <>
    //         <span>
    //           {row.row.original.project_number != null &&
    //           row.row.original.project_number != "" ? (
    //             <span>{row.row.original.project_number}</span>
    //           ) : (
    //             <span>{"---"} </span>
    //           )}
    //         </span>
    //       </>
    //     );
    //   },
    // },

    {
      Header: "Created Date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
        return (
          <>
            <div className="CreatedDatelisted">
              {/* {`${
                row.row.original.created_at.slice(0, 10)
                //  + "  " + formattedTime
              }`} */}
                                          {row.row.original.created_at ? formatedDateListwithouttime(row.row.original.created_at)
                                : ""
                            }
            </div>
          </>
        );
      },
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                              type="button"
                className=" btn Status"
                onClick={(e) => {
                  e.stopPropagation();
                  setEditId(row.row.original.id);
                  setClientcreate(true);
                }}
                // component="span"
              >
                <span className="OuterActionSpan">
               
                  <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>
{State.ClientBranchIDs.SUBROLE == 3 && (

              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  e.stopPropagation();
                  setDeleteID(row.row.original.id);
                  setDeletePOPUP(true);
                }}
              >
                <span className="OuterActionSpan">
            
<span  className="EditImages">
                    <img src={DeleteImages}/>
                  </span>

                  <span className="ActionsList"> Delete </span>
                </span>
              </button>
              )}


            </div>
          </>
        );
      },
    },
  ];
   const currentRef = useRef();
  const [trigger,setTrigger] = useState(false)
  const scrollPosition = (e) => {
    const val = currentRef.current.scrollTop;
    sessionStorage.setItem("clientTableScrollPosition", val);
    setTrigger(!trigger)
  };

  return (
    <>
      <div 
                    onScroll={scrollPosition}
              ref={currentRef}

      className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            // className="InnerUsers col-md-6"
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3 class="user-name mb-0">Client </h3>

            {/* <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <NavLink
                  style={{ textDecoration: "none", color: "#333333" }}
                  to={"/client"}
                  onClick={(e) => {
                    dispatch(getSideBarfilesActions("Client"));
                  }}
                >
                  Client
                </NavLink>
              </li>
            </ul> */}
          </div>
          <div className="createticketing col-sm-5">
            <button
              onClick={(e) => {
                setClientcreate(true);
                setEditId("");
              }}
              className="Createbutton"
            >
              {" "}
              Create{" "}
            </button>
          </div>
        </div>
<br/>

        {Data != undefined ? (
          <div style={{ padding: " 0px 40px", marginTop: "-10px" }}>
            <ReactTable
              data={State.ClientList.ClientLists}
              columns={columns}
              totalItems={State.ClientList.Total_Count}
              currentPage={currentPage}
              // onPageChange={handlePageChange}
              onChange={tochange}
              MakeCreate={true}
              setCurrentPage={setCurrentPage}
              pagesize={pagesize}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}
              // dtpageindex={currentPage}
              dtpagesize={dtpagesize}
              dtpageindex={dtpageindex}
              pageindex={pageindex}
              datacount={State.ClientList.Total_Count}

              Oncreate={(e) => {
                setClientcreate(true);
                setEditId("");
              }}
              ViewParts={(e) => {
                dispatch(setClient_objects_store(e))
                dispatch(setTheClientNamelisted(e.client_name));
                handleClick(e.id);
              }}
              Filter={true}
              NoFilter={true}
              nostatusFilter={true}
              searchVal={TablePositionPersist?.clientPage?.search == "" || TablePositionPersist?.clientPage?.search ==undefined? "":TablePositionPersist.clientPage.search}
              search_key={true}
            />
          </div>
        ) : null}
      </div>

      {ClientCreatePOpup ? (
        <ClientCreate
          show={ClientCreatePOpup}
          setShow={setClientcreate}
          currentPage={dtpageindex}
          EditId={EditID}
          // Datamonth={Datamonth}
                    currentRef={currentRef}

        />
      ) : null}

      {DeletePOPUP ? (
        <Delete
          show={DeletePOPUP}
          setShow={setDeletePOPUP}
          onSubmit={HandelDelete}
          Content={"Do you want to delete the Client"}
        />
      ) : null}

    </>
  );
};

export default Client;
